import { Modal as ChakraModal, ModalContent, ModalCloseButton, ModalBody, ModalOverlay } from '@chakra-ui/react';

export default function Modal({ children, isOpen, onClose, isCentered = false, size = '4xl' }) {
  return (
    <ChakraModal isOpen={isOpen} size={size} isCentered={isCentered} onClose={onClose}>
      <ModalOverlay bg="#00000039" backdropFilter="blur(2px)" />
      <ModalContent>
        <ModalCloseButton zIndex={1} />
        <ModalBody py={10}>{children}</ModalBody>
      </ModalContent>
    </ChakraModal>
  );
}
